import deDEEnums from './locales/de/enums.json'
import deDETranslation from './locales/de/translation.json'
import enUSTranslation from './locales/en/translation.json'
import enUSEnums from './locales/en/enums.json'

const Languages = {
  de: 'de',
  en: 'en',
}

export const resources = {
  [Languages.en]: {
    enums: enUSEnums,
    translation: enUSTranslation,
  },
  [Languages.de]: {
    enums: deDEEnums,
    translation: deDETranslation,
  },
}

export function fallbackLng(code: string) {
  const fallbacks = ['en']
  const [lang] = code.split(/[_-]/)
  const normalizedLang = lang.toLowerCase()

  if (!fallbacks.includes(normalizedLang)) {
    fallbacks.unshift(normalizedLang)
  }

  return fallbacks
}
